import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ManageProfileCommon } from './manage-profile-common';

@Component({
  selector: 'app-manage-profile',
  templateUrl: './manage-profile.component.html',
  styleUrls: ['./manage-profile.component.css'],
})
export class ManageProfileComponent implements OnInit {
  // employeeForm:FormGroup
  empType = 'Employee';
  modalStatus='';
  closeResult = '';
  // model: NgbDateStruct;
  // model1: NgbDateStruct;
  // model2: NgbDateStruct;
  // model3: NgbDateStruct;
  employeeTypeList= [{id:3,name:'Article'},{id:2,name:'Consultant'},{id:3,name:'Employee'}]
  employeeForm;
  employeeFormSubmitted=false;
  employeeFormErrors = ManageProfileCommon.employeeFormErrors;
  employeeFormValidationMessages = ManageProfileCommon.employeeFormValidationMessages;

  constructor(private modalService: NgbModal,private fb: FormBuilder,private ngbDateParserFormatter: NgbDateParserFormatter) {
  }

  openModal(content,status) {
    this.modalStatus = status;
     if(!(this.modalStatus=='edit')){
      // this.resetModalObject();
      this.resetEmployeeForm();
     } 
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'xl',windowClass : "animate__animated animate__slideInUp animate__faster"}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed`;
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  ngOnInit() {
    console.log("ngOnInit");
    // init form
    this.initEmployeeForm();
    // console.log(this.registrationForm);/
    this.employeeForm.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.employeeForm);
   
    });
  }

  initEmployeeForm(){
    this.employeeForm = this.fb.group({
      firstName :  ['', [Validators.required,Validators.maxLength(50)]],
      middleName :  ['', [Validators.required,Validators.maxLength(50)]],
      lastName :  ['', [Validators.required,Validators.maxLength(50)]],
      dateOfBirth :  ['', [Validators.required]],
      bloodGroup:  ['', [Validators.required]],
      panNumber:  ['', [Validators.required]],
      aadharNumber: ['', [Validators.required]],
      qualification:  ['', [Validators.required]],
      certification:  ['', [Validators.required]],
      gender:  ['', []],
      profileStatus:  ['closed', [Validators.required]],
      loginAccess:  [false, [Validators.required]],
      //
      email:['', [Validators.required]],
      personalEmail:['', [Validators.required]],
	    officalMobileNumber:['', [Validators.required]],
	    contactMobileNumber:['', [Validators.required]],
	    landlineStdCode:['', [Validators.required]],
      landlineNumber:['', [Validators.required]],
      emergencyContactNumber1:['', [Validators.required]],
	    emergencyContactName1:['', [Validators.required]],
	    emergencyContactRelation1:['', [Validators.required]],
	    emergencyContactNumber2:['', [Validators.required]],
	    emergencyContactName2:['', [Validators.required]],
	    emergencyContactRelation2:['', [Validators.required]],
      permanentAddress: this.fb.group({
        address:['', [Validators.required]],
        city:['', [Validators.required]],
        state:['', [Validators.required]],
        postalCode:['', [Validators.required]],
        country:['', [Validators.required]],        
        type:['permanent'],        
      }),
      localAddress: this.fb.group({
        address:['', [Validators.required]],
        city:['', [Validators.required]],
        state:['', [Validators.required]],
        postalCode:['', [Validators.required]],
        country:['', [Validators.required]],        
        type:['local'],       
      }),
      //
      branch:['', [Validators.required]], 
      role:['', [Validators.required]],
      designation:['', [Validators.required]],
      reportingManager:['', [Validators.required]],     
	    reportingPartner:['', [Validators.required]],     
	    joiningDate:['', [Validators.required]],     
	    membershipNumber:['', [Validators.required]],     
	    probabtionPeriod:['', [Validators.required]],     
	    articleTrainingLimit:['', [Validators.required]],     
	    isVerified:['', [Validators.required]],     
	    confirmationDate:['', [Validators.required]],     
	    verificationSource:['', [Validators.required]],     
	    remark:['', [Validators.required]],     
	    laptopServiceTagNumber:['', [Validators.required]],     
	    dataCardNumber:['', [Validators.required]],     
	    bankAcountName:['', [Validators.required]],     
	    bankAccountNumber:['', [Validators.required]],     
	    icaiRegistrationDate:['', [Validators.required]],     
	    icaiRegistrationNumber:['', [Validators.required]],     
	    articleshipEndDate:['', [Validators.required]],     
      registeredPartner:['', [Validators.required]],     
      //
      basic:['', [Validators.required]],     
	    hra:['', [Validators.required]],     
      // mobileAllowance:['', [Validators.required]],  
      otherAllowance:['', [Validators.required]],     
	    conveyanceAllowance:['', [Validators.required]],     
	    medicalAllowance:['', [Validators.required]],     
	    educationAllowance:['', [Validators.required]],     
	    childHostelAllowance:['', [Validators.required]],     
	    fromDate:['', [Validators.required]],     
      toDate:['', [Validators.required]],     
       
    })
  }


  onSaveBtnClick(){
    console.log(this.employeeForm);
    this.employeeFormSubmitted=true;
    this.logValidationErrors(this.employeeForm);
    // this.logKeyValuePairs(this.employeeForm);
  }

  resetEmployeeForm(){
    this.employeeFormSubmitted = false;
    this.employeeForm.reset();
  }


  logValidationErrors(group: FormGroup): void {
      // Loop through each control key in the FormGroup
    Object.keys(group.controls).forEach((key: string) => {
      // Get the control. The control can be a nested form group
      const abstractControl = group.get(key);
      // If the control is nested form group, recursively call this same method
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
        // If the control is a FormControl
      } else {
        console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
        // Clear the existing validation errors
        this.employeeFormErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.employeeFormSubmitted) { 
          // Get all the validation messages of the form control that has failed the validation
          const messages = this.employeeFormValidationMessages[key];
          console.log(messages)
          // Find which validation has failed. For example required, minlength or maxlength. 
          // Store that error message in the formErrors object. 
          // The UI will bind to this object to display the validation errors
          for (const errorKey in abstractControl.errors) {
            console.log(errorKey)
            if (errorKey) {
              this.employeeFormErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
  
  logKeyValuePairs(group: FormGroup): void {
    // loop through each key in the FormGroup
    Object.keys(group.controls).forEach((key: string) => {
      // Get a reference to the control using the FormGroup.get() method
      const abstractControl = group.get(key);
      // If the control is an instance of FormGroup i.e a nested FormGroup
      // then recursively call this same method (logKeyValuePairs) passing it
      // the FormGroup so we can get to the form controls in it
      if (abstractControl instanceof FormGroup) {
        this.logKeyValuePairs(abstractControl);
        // If the control is not a FormGroup then we know it's a FormControl
      } else {
        console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
      }
    });
  }


}
